<div class="content-wrapper-inner">
  <div class="page-content">
    <div class="table-topbar mb-20">
      <div class="table-action-holder">
        <div class="create">
          <a (click)="create()" class="btn btn-primary py-10 px-15"><span class="icon-add"></span>Create stop word</a>
        </div>
      </div>
    </div>
    <div>
      <app-stop-words-table (actions)="onAction($event)"></app-stop-words-table>
    </div>
  </div>
</div>

<ng-template #formModalTpl let-dialogRef="dialogRef">
  <div class="modal-header mb-10">
    <div class="modal-title">
      <h3 class="d-inline-block" *ngIf="model && !model.id">Add content</h3>
      <h3 class="d-inline-block" *ngIf="model && !model.id">Edit content</h3>
      <button type="button" class="btn-close" (click)="dialogRef.close(false)">
        <span class="icon-close"></span>
      </button>
    </div>
  </div>
  <div class="modal-body">
    <form (ngSubmit)="onSubmit()" [formGroup]="form" class="pos-relative form">
      <div [hidden]="!formLoading" class="spinner">
        <div class="sk-spinner sk-spinner-pulse"></div>
      </div>
      <div class="form-group">
        <div class="row">
          <div class="col-md-12">
            <label class="form-label required">Content </label>
            <input autocomplete="off" [(ngModel)]="model.content" formControlName="content" type="text" class="form-control">
            <input-errors [control]="form.controls.content" [service]="validationService"></input-errors>
          </div>
        </div>
      </div>
      <div class="form-group mt-20">
        <div class="row">
          <div class="col-md-4">
            <label class="form-label">LNT </label>
            <div class="form-check form-switch">
              <input type="checkbox" class="form-check-input medium" [(ngModel)]="model.lnt" formControlName="lnt">
            </div>
          </div>
          <div class="col-md-4">
            <label class="form-label">MNT </label>
            <div class="form-check form-switch">
              <input type="checkbox" class="form-check-input medium" [(ngModel)]="model.mnt" formControlName="mnt">
            </div>
          </div>
          <div class="col-md-4">
            <label class="form-label">MO </label>
            <div class="form-check form-switch">
              <input type="checkbox" class="form-check-input medium" [(ngModel)]="model.mo" formControlName="mo">
            </div>
          </div>
        </div>
      </div>
      <hr class="mt-20">

      <div class="text-right buttons mt-10 mb-10">
        <button type="submit" [disabled]="!form.valid" class="btn btn-primary px-20">Apply</button>
      </div>
    </form>
  </div>
</ng-template>
